import $ from 'jquery';
import Plyr from 'plyr/dist/plyr.polyfilled.js';
import 'plyr/src/sass/plyr.scss';
import './_plyr-io-custom.scss';
import browserdetect from '../browserdetect/browserdetect';

export default function (elemSelector, options) {
  const self = {
    identifier: Math.round(Math.random() * 99999).toString(),
    elem: null,
    options: null,
    playerLoaded: false,

    defaultOptions: {
      playOnHover: false,
      storage: false,
      //  Default Plyr configuration
      controls: [
        'play', // Play/pause playback
        'progress', // The progress bar and scrubber for playback and buffering
        'current-time', // The current time of playback
        'duration', // The full duration of the media
        'mute', // Toggle mute
        'volume', // Volume control
        'fullscreen',
      ],
    },

    init (elem, initialOptions = {}) {
      self.elem = elem;
      self.options = $.extend(self.defaultOptions, initialOptions);
      self.elem.attr('poster', '');

      self.loadPlayer();
      if (self.options.playOnHover) {
        self.elem.hover(self.play, self.pause);
      }

      $(window).on('brandhub-video-playback', (event) => {
        if (event.identifier !== self.identifier && !self.elem[0].autoplay) {
          self.pause();
        }
      });
    },

    loadPlayer () {
      if (self.playerLoaded) {
        return;
      }
      // lazy load video file if given as data-src instead of src
      if (!self.elem.find('source').attr('src') && self.elem.find('source').attr('data-video-src')) {
        self.elem.find('source').attr('src', self.elem.find('source').data('video-src'));
        self.elem[0].load();
      }

      if (!self.elem.attr('controls')) {
        self.options.controls = false;
        self.options.clickToPlay = false;
      }

      if (self.elem.prop('autoplay')) {
        self.options.muted = true;
      }

      // load plyr
      self.player = new Plyr(self.elem[0], self.options);
      self.playerLoaded = true;
    },

    handleVideoPromise (from, to) {
      if (!browserdetect.isSafari) {
        return;
      }

      const toFrom = to || from;
      const videoPromise = self.player[from]();
      if (videoPromise !== undefined) {
        videoPromise.then(() => {
          self.player[toFrom]();
        });
      }
    },

    play () {
      $(window).trigger('brandhub-video-playback', self.identifier);
      if (self.player) {
        self.player.play();
      }
    },

    pause () {
      if (self.player) {
        self.player.pause();
      }
    },
  };

  self.init($(elemSelector).first(), options);

  return self;
}



// WEBPACK FOOTER //
// ./custom_dependencies/brandhub-embxp-frontend/daimler-brandhub-modules/daimler-brandhub-design/daimler-brandhub-design-package/frontend/src/common/js/mp4player/mp4player.js